const route = {
	path: 'accounting-analysis',
	name: 'accounting-analysis',
	meta: {
		title: 'Análisis Contable',
	},
	component: () => import('@/pages/accounting-analysis/page-accounting-analysis'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/accounting-analysis.js